import { Box, Typography } from "@mui/material";
import { AddRounded, RemoveRounded } from "@mui/icons-material";
import { CustomCounterProps } from "utils/interface";
import { CustomIconButton } from "../custom-button/CustomButton";

export default function CustomCounter({
  disabled,
  quantity,
  handleIncrement,
  handleDecrement,
  disableDec,
}: CustomCounterProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <CustomIconButton
        onClick={handleDecrement}
        disabled={disableDec || disabled}
        color="primary"
      >
        <RemoveRounded />
      </CustomIconButton>
      <Typography
        color={disabled ? "text.disabled" : "black"}
        style={{
          margin: "2px",
        }}
      >
        {quantity}
      </Typography>
      <CustomIconButton
        onClick={handleIncrement}
        color="primary"
        disabled={disabled}
      >
        <AddRounded />
      </CustomIconButton>
    </Box>
  );
}
